export default "__VITE_ASSET__Bf0jc41F__"